import { Config, Stage } from '@3fourteen/core';
import { memo, useEffect, useState } from 'react';

import { NavLink } from 'components';
import { IS_PRODUCTION } from 'services/environment';
import { routes } from 'services/routes';

// Cache the result to avoid repeated fetches across navigation renders
let customResearchExistsCache: boolean | null = null;
let customResearchCheckPromise: Promise<boolean> | null = null;

function CustomResearchNavLink() {
  const [hasCustomResearch, setHasCustomResearch] = useState<boolean | null>(
    customResearchExistsCache
  );

  useEffect(() => {
    // If we already have a cached result, use it
    if (customResearchExistsCache !== null) {
      setHasCustomResearch(customResearchExistsCache);
      return;
    }

    // If there's already a pending check, wait for it
    if (customResearchCheckPromise) {
      customResearchCheckPromise.then((exists) => {
        setHasCustomResearch(exists);
      });
      return;
    }

    // Create a new check
    const stage = IS_PRODUCTION ? Stage.prod : Stage.dev;
    customResearchCheckPromise = fetch(`${Config[stage].apiUrl}/custom-research/index.html`, {
      method: 'HEAD',
      credentials: 'include',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'text/plain',
      },
    })
      .then((res) => {
        const exists = res.ok;
        customResearchExistsCache = exists;
        customResearchCheckPromise = null;
        setHasCustomResearch(exists);
        return exists;
      })
      .catch(() => {
        // Silently handle errors - custom research may not exist
        // Network errors, CORS errors, etc. are expected and handled gracefully
        customResearchExistsCache = false;
        customResearchCheckPromise = null;
        setHasCustomResearch(false);
        return false;
      });
  }, []);

  if (hasCustomResearch === null || !hasCustomResearch) return null;

  return (
    <NavLink
      href={routes.customResearch}
      text='Custom Research'
      key={routes.customResearch}
      icon='settings'
      iconFamily='simple-line'
    />
  );
}

CustomResearchNavLink.displayName = 'CustomResearchNavLink';

export default memo(CustomResearchNavLink);
